module.exports = __webpack_public_path__ + "static/media/Sec-1_HomePageWeb_CN_Euro.8844ab69.webp";